import { LinkExternal01Icon } from '@langchain/untitled-ui-icons';
import CircularProgress from '@mui/joy/CircularProgress';

import { useNavigate } from 'react-router-dom';

import { useSWRMutation } from '../../../hooks/useSwr';
import { FeedbackSchema, RunSchema } from '../../../types/schema';
import { apiRunsPath } from '../../../utils/constants';

export function getRunId(row: FeedbackSchema) {
  return row.feedback_source?.metadata?.__run?.run_id;
}

export function SourceRunAction({
  feedback,
  className,
}: {
  feedback: FeedbackSchema;
  className?: string;
}) {
  const navigate = useNavigate();
  const runId = getRunId(feedback);
  const fetchRunUrl = useSWRMutation<RunSchema, never>({
    url: `${apiRunsPath}/${runId}`,
    method: 'GET',
  });

  async function openLink(openInNewTab: boolean) {
    const run = await fetchRunUrl.trigger({});

    if (run) {
      if (openInNewTab) {
        window.open(run?.app_path, '_blank');
      } else {
        navigate(run?.app_path);
      }
    }
  }

  if (!runId) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={(e) => openLink(e.metaKey || e.ctrlKey)}
      onAuxClick={(e) => openLink(e.button === 1)}
      className={className}
    >
      {fetchRunUrl.isMutating ? (
        <CircularProgress size="sm" color="neutral" />
      ) : (
        <LinkExternal01Icon className="size-4" />
      )}
    </button>
  );
}
